import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import useFetch from "../hooks/useFetch";
import Typography from "@mui/material/Typography";
import StarIcon from "@mui/icons-material/Star";
import dayjs from "dayjs";

function Review() {
  const fetchData = useFetch();

  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const response = await fetchData("/api/rating");
    setData(response);
    setLoading(false);
  }

  const columns = [
    {
      field: "referenceCode",
      headerName: "SKU",
      flex: 1,
      sortable: false,
      minWidth: 150,
    },
    {
      field: "ratingFrom",
      headerName: "Vorige waardering",
      width: 150,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Typography variant={"body2"} sx={{ lineHeight: 1 }}>
              {params.row.rating.countFrom}
            </Typography>
          </Box>
        );
      },
      valueGetter: (_, y) => y?.row?.rating?.countFrom,
    },
    {
      field: "ratingdifference",
      headerName: "Verschil",
      width: 100,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Typography variant={"body2"}>
              {params.row.rating.countDifference}
            </Typography>
          </Box>
        );
      },
      valueGetter: (_, y) => y?.row?.rating?.countDifference,
    },
    {
      field: "ratingTo",
      headerName: "Nieuwe waardering",
      width: 150,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Typography variant={"body2"} sx={{ lineHeight: 1 }}>
              {params.row.rating.countTo}
            </Typography>
          </Box>
        );
      },
      valueGetter: (_, y) => y?.row?.rating?.countTo,
    },
    {
      field: "lastRating",
      headerName: "Laatste review",
      width: 150,
      // valueGetter: (_, y) => y?.row?.rating?.lastRating,
      valueGetter: (_, y) => {
        const rawDate = y?.rating?.lastRating;
        return rawDate ? new Date(rawDate) : null;
      },
      valueFormatter: (_, y) =>
        y?.rating?.lastRating
          ? dayjs(y.rating.lastRating).format("DD-MM-YY")
          : "",
      sortComparator: (a, b) => {
        return new Date(a) - new Date(b);
      },
    },
  ];

  return (
    <>
      <DataGrid
        rows={data}
        columns={columns}
        getRowId={(row) => row.referenceCode}
        density="compact"
        loading={loading}
        sx={{
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
        }}
        localeText={{
          noRowsLabel: "Geen reviews gevonden",
        }}
        sortModel={[
          {
            field: "lastRating",
            sort: "desc",
          },
        ]}
      />
    </>
  );
}

export default Review;
